/** @file prepareCurveFrame memoized on its inputs: a repaint that only moves the playhead reuses the scene. */
import type { KeyRef } from '../../stores/types';
import type { CurveTrack } from './curveTypes';
import type { CurveViewState } from './curveViewStore';
import { prepareCurveFrame, type CurvePrep } from './prepareCurveFrame';

/** A prepare function that re-samples the curves and rebuilds the hit grid only when tracks, keys, view or size change. */
export function curvePrepCache(): typeof prepareCurveFrame {
  let last: { tracks: readonly CurveTrack[]; keys: readonly KeyRef[]; view: CurveViewState; width: number; height: number; prep: CurvePrep } | null = null;
  return (tracks, keys, view, size) => {
    const prev = last;
    const hit = prev?.tracks === tracks && prev.keys === keys && prev.view === view && prev.width === size.width && prev.height === size.height;
    if (hit) return prev.prep;
    const prep = prepareCurveFrame(tracks, keys, view, size);
    last = { tracks, keys, view, ...size, prep };
    return prep;
  };
}
